import {
  Create,
  Datagrid,
  Edit,
  ImageField,
  List,
  ReferenceField,
  ReferenceInput,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  EditButton,
  DeleteButton,
  DateField,
} from "react-admin";
import UploadImage from "../shared/uploadImage";
import { RichTextInput } from "ra-input-rich-text";
import { BlogEditor } from "./components/blog-editor";

export const BlogsList = (props) => {
  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="title" />
        <TextField source="summary" />
        <ImageField source="image" />
        <DateField source="created_at" label="Date" />
        <EditButton></EditButton>
        <DeleteButton mutationMode="pessimistic" />
      </Datagrid>
    </List>
  );
};

export const BlogsCreate = (props) => {
  return (
    <Create title="Create a Blog" {...props} dir="ltr" redirect="list">
      <SimpleForm>
        <TextInput source="title" />
        <TextInput source="summary" />
          <ReferenceInput 
          source="category_id"
          reference="media-categories"
          label="Category"
          filter={{ type: 'blog', isActive: true }}
          sort={{ field: 'name', order: 'ASC' }}
        >
          <SelectInput 
            optionText="name"
            optionValue="id"
            fullWidth
          />
        </ReferenceInput>
        <div className="border w-full p-3 border-primary rounded-lg">
          <UploadImage name="image" />
        </div>
        <div className="w-full">
          <BlogEditor />
          {/* <RichTextInput source="content" className="" /> */}
        </div>
      </SimpleForm>
    </Create>
  );
};

const UserEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export const BlogsEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm toolbar={<UserEditToolbar />}>
        <TextInput source="title" />
        <TextInput source="summary" />
         {/* <ReferenceField 
          source="category_id" 
          reference="media-categories"
          label="Category"
        >
          <TextField source="name" />
        </ReferenceField> */}
        <ReferenceInput
         source="category_id"
          reference="media-categories"
          label="Category"
          filter={{ type: 'blog', isActive: true }}
          sort={{ field: 'name', order: 'ASC' }}
        >
          <SelectInput 
            optionText="name"
            optionValue="id"
            fullWidth
          />
        </ReferenceInput>
        <div className="border w-full p-3 border-primary rounded-lg">
          <UploadImage name="image" />
        </div>
        <BlogEditor />
        {/* <RichTextInput source="content" width={"100%"}/> */}
      </SimpleForm>
    </Edit>
  );
};
